import { Box, styled } from '@mui/material';

export const TableFlexOverflowContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  overflow: 'auto',
});
